import { Newsletters } from './pages';

export default {
  key: 'newsletters',
  isPrivate: true,
  exact: true,
  path: ['/school-newsletters', '/list'],
  component: Newsletters,
};
